import { differenceInDays, isSameDay, parseISO, startOfDay, isWithinInterval, areIntervalsOverlapping } from 'date-fns';
import { Event } from "../lib/types";

// Function to determine if an event spans multiple days
export const isMultiDayEvent = (event: Event) => {
  const eventStart = parseISO(event.dateStart);
  const eventEnd = parseISO(event.dateEnd);
  return !isSameDay(eventStart, eventEnd);
};

// Function to find start and end indices for multi-day events
export const getEventIndices = (event: Event, startDate: Date, daysToShow: number) => {
  const eventStart = parseISO(event.dateStart);
  const eventEnd = parseISO(event.dateEnd);

  const startDayIndex = Math.max(0, differenceInDays(eventStart, startDate));
  const endDayIndex = Math.min(daysToShow - 1, differenceInDays(eventEnd, startDate));

  return { startDayIndex, endDayIndex };
};

// Function to get events for a specific day
export const getEventsForDay = (filteredEvents: Event[], day: Date) => {
  const dayStart = startOfDay(day);
  const dayEnd = new Date(dayStart);
  dayEnd.setHours(23, 59, 59, 999);

  return filteredEvents.filter(event => {
    const eventStart = parseISO(event.dateStart);
    const eventEnd = parseISO(event.dateEnd);

    // For single-day events, check if the event is on this specific day
    if (isSameDay(eventStart, eventEnd)) {
      return isSameDay(eventStart, day);
    }

    // For multi-day events, check if this day falls within the event's range
    return isWithinInterval(day, { start: eventStart, end: eventEnd });
  });
};

// Function to check if an event is within a date range
export const isEventInDateRange = (event: Event, startDate: Date, endDate: Date) => {
  const eventStart = parseISO(event.dateStart);
  const eventEnd = parseISO(event.dateEnd);

  // Create intervals for the event and the visible date range
  const eventInterval = { start: eventStart, end: eventEnd };
  const visibleRange = { start: startDate, end: endDate };

  // Check if the intervals overlap
  return areIntervalsOverlapping(eventInterval, visibleRange);
};
